import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
  FDPrimaryActionButton,
  FDPrimaryActionIconButton, FDSecondaryActionButton,
} from '@facet-wealth/design';
import { DialogActions, DialogContent, DialogTitle } from 'Views/Page/Content/Modal/Components';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { ErrorList2 } from 'Components/ComponentLibrary/Molecules/ErrorList2';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { dataAttrs } from 'Helpers/Testing';
import ClientAccordion from './ClientAccordion';
import metaOverrideSet from '../metaOverrideSet';

const Layout = () => {
  const {
    resource,
    onSubmit,
    saving,
    errors,
  } = useMetaLayoutContext();
  const [deleting, setDeleting] = useState(false);
  const { loadModalCollectionByLink, setModalCollection } = useModalContext();
  const [expandedID, setExpandedID] = useState(resource.attr('clients')?.resources().head()?.id());
  const { displayErrorMessage } = useSnackbarContext();

  return (
    <React.Fragment>
      <DialogTitle value={resource.attr('title')} />
      <DialogContent>
        <FDStack direction="column" spacing={2}>
          <MetaControlField attr="description" />
          <MetaControlField attr={'securityMessage'} />
          <FDStack direction="column" spacing={1} width="100%">
            <MetaCollectionFormInline
              padding="none"
              collection={resource.attr('clients')}
              metaOverrideSet={metaOverrideSet}
              FormProps={{
                layout: ClientAccordion,
                LayoutProps: {
                  expandedID,
                  setExpandedID,
                },
                noIndividualSubmitButtons: true,
              }}
            />
          </FDStack>
          <ErrorList2 title={'Validation Errors'} errors={errors} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        <FDSecondaryActionButton
          {...dataAttrs('skip-btn', resource)}
          loading={deleting}
          disabled={saving || deleting}
          onClick={async () => {
            setDeleting(true);
            try {
              setModalCollection(await resource.delete());
              setDeleting(false);
            } catch (err) {
              displayErrorMessage(err, 'Error declining');
              setDeleting(false);
            }
          }}
          label="No thanks"
        />
        <FDPrimaryActionButton
          {...dataAttrs('continue-btn', resource)}
          loading={saving}
          disabled={saving || deleting}
          onClick={onSubmit}
          label="Find ways to save"
        />
      </DialogActions>
      <MetaControlField attr={'disclosure'} />
    </React.Fragment>
  );
};

export default Layout;
